import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const footerSelector = state => state.app.footer;

const isFooterFixed = createSelector(footerSelector, footer => footer.fixed);

export default isFooterFixed;



// WEBPACK FOOTER //
// ./src/_selectors/appSelectors/isFooterFixed.js